import React from "react";
import { useTranslation } from "react-i18next";

import AppPreviewDashboard from "./AppPreviewDashboard";
import AnimatedEmptyState from "./AnimatedEmptyState";
import WorkflowEmptyState from "./WorkflowEmptyState";
import WorkflowCanvas from "./Canvas/WorkflowCanvas";
import { useWorkflow } from "../../context/WorkflowContext";
import { useWorkflowGeneration } from "../../context/WorkflowGenerationContext";

function RightPanel({ confirm }) {
    const { workflow, steps } = useWorkflow();
    const { handleErrorLog, isGeneratingCode } = useWorkflowGeneration();
    const { t } = useTranslation();

    if (workflow?.workflowType === "APP_V2") {
        return (
            <AppPreviewDashboard
                workflow={workflow}
                handleErrorLog={handleErrorLog}
                key={workflow?.id + workflow?.currentVersion}
            />
        );
    }

    const hasNoCode =
        !steps ||
        steps.length === 0 ||
        steps.every(
            (step) => !step.config?.code || step.config.code.trim() === ""
        );

    if (isGeneratingCode && hasNoCode) {
        return (
            <div className="h-full border-l border-gray-200">
                <AnimatedEmptyState
                    title={t("stepsExecutionPanel.creatingYourSteps")}
                    subtitle={t("stepsExecutionPanel.thisWillJustTakeAMoment")}
                    titleColor="text-blue-600"
                />
            </div>
        );
    }

    if (hasNoCode) {
        return (
            <div className="h-full border-l border-gray-200">
                <WorkflowEmptyState />
            </div>
        );
    }

    if (!workflow?.workflowType) {
        return (
            <div className="h-full border-l border-gray-200">
                <AnimatedEmptyState
                    title={t("stepsExecutionPanel.startChatting")}
                    subtitle={t("stepsExecutionPanel.startByChattingWithAI")}
                />
            </div>
        );
    }

    return (
        <div className="h-full border-l border-gray-200">
            <WorkflowCanvas key={workflow?.id} />
        </div>
    );
}

export default React.memo(RightPanel);
